import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-647cb186"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "8px"
  }
}, "上传", -1));
const _hoisted_3 = ["src"];
import { ref, computed, watch } from 'vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'OtherReasonModal',
  props: {
    modelVisible: {
      type: Boolean
    },
    currentRecord: null,
    reasonMap: null
  },
  emits: ['update:modelVisible', 'confirm', 'cancel'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const localRecord = ref({
      receivedResCode: [],
      receivedResMsg: ''
    });
    const initializeData = (record, isModalOpening = false) => {
      var _record$receivedResEx, _record$receivedResEx2;
      if (!record) return;
      if (isModalOpening) {
        localRecord.value = {
          ...record,
          receivedResCode: [],
          receivedResMsg: ''
        };
        return;
      }
      // 处理 receivedResExtInfo 相关逻辑
      if (record !== null && record !== void 0 && (_record$receivedResEx = record.receivedResExtInfo) !== null && _record$receivedResEx !== void 0 && (_record$receivedResEx = _record$receivedResEx.receivedResList) !== null && _record$receivedResEx !== void 0 && _record$receivedResEx.length) {
        localRecord.value.receivedResCode = record.receivedResExtInfo.receivedResList.map(item => item.receivedResCode);
        // 只有当存在code为60的项时，才设置receivedResMsg
        const code60Item = record.receivedResExtInfo.receivedResList.find(item => item.receivedResCode === '60');
        localRecord.value.receivedResMsg = (code60Item === null || code60Item === void 0 ? void 0 : code60Item.receivedResMsg) || '';
      } else {
        localRecord.value.receivedResCode = [];
        localRecord.value.receivedResMsg = '';
      }
      // 处理图片列表逻辑
      if (record !== null && record !== void 0 && (_record$receivedResEx2 = record.receivedResExtInfo) !== null && _record$receivedResEx2 !== void 0 && (_record$receivedResEx2 = _record$receivedResEx2.imageList) !== null && _record$receivedResEx2 !== void 0 && _record$receivedResEx2.length) {
        fileList.value = record.receivedResExtInfo.imageList.map((url, index) => ({
          uid: `-${index}`,
          name: `图片${index + 1}`,
          status: 'done',
          url: url,
          fileUrl: url
        }));
      } else {
        fileList.value = [];
      }
    };
    // 监听 modal 显示状态
    watch(() => props.modelVisible, newVal => {
      if (newVal) {
        initializeData(props.currentRecord);
      }
    });
    const showTextArea = computed(() => {
      var _localRecord$value$re;
      return (_localRecord$value$re = localRecord.value.receivedResCode) === null || _localRecord$value$re === void 0 ? void 0 : _localRecord$value$re.includes('60');
    });
    const reasonOptions = computed(() => {
      if (!props.reasonMap) return [];
      const entries = Object.entries(props.reasonMap);
      // 将"其他"选项（code 为 '60'）放在最后
      const sortedEntries = entries.sort(([a], [b]) => {
        if (a === '60') return 1;
        if (b === '60') return -1;
        return 0;
      });
      return sortedEntries.map(([value, label]) => ({
        value,
        label
      }));
    });
    const fileList = ref([]);
    const previewVisible = ref(false);
    const previewImage = ref('');
    const previewTitle = ref('');
    const handleReceivedResCodeChange = values => {
      localRecord.value.receivedResCode = values;
      // 如果移除了code 60，清空文本信息
      if (!values.includes('60')) {
        localRecord.value.receivedResMsg = '';
      }
    };
    const handlePreview = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || file.preview;
      previewVisible.value = true;
      previewTitle.value = file.name;
    };
    const handleCancel = () => {
      previewVisible.value = false;
    };
    const handleUploadImage = async options => {
      const {
        file,
        onSuccess,
        onError
      } = options;
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('accessAttribute', '1');
        formData.append('businessId', props.currentRecord.id);
        formData.append('businessType', 'ACCOUNT_BILL');
        const response = await uploadAuditScreenshot(formData);
        const fileData = response.data;
        onSuccess(response);
        // 匹配filelist中name相同的文件
        const fileItem = fileList.value.find(item => item.name === fileData.originalFilename);
        if (fileItem) {
          fileItem.fileUrl = fileData.fileUrl;
        }
      } catch (error) {
        onError(error);
      }
    };
    const handleOtherReasonConfirm = () => {
      const receivedResList = localRecord.value.receivedResCode.map(code => {
        if (code === '60') {
          return {
            receivedResCode: code,
            receivedResMsg: localRecord.value.receivedResMsg
          };
        }
        // 使用reasonMap获取对应的label作为receivedResMsg
        return {
          receivedResCode: code,
          receivedResMsg: props.reasonMap[code] || ''
        };
      });
      emit('confirm', {
        currentRecord: {
          ...props.currentRecord,
          receivedResExtInfo: {
            ...(localRecord.value.receivedResExtInfo || {}),
            receivedResList,
            imageList: fileList.value.map(file => file.fileUrl)
          }
        },
        fileUrls: fileList.value.map(file => file.fileUrl)
      });
    };
    const handleOtherReasonCancel = () => {
      emit('cancel');
      emit('update:modelVisible', false);
    };
    const getBase64 = file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    };
    expose({
      initializeData
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modelVisible,
        title: "异常原因",
        onOk: handleOtherReasonConfirm,
        onCancel: handleOtherReasonCancel,
        centered: "",
        width: "700px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, null, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "异常原因"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: localRecord.value.receivedResCode,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => localRecord.value.receivedResCode = $event),
              class: "edit-button",
              popupClassName: "reason-select-popup",
              options: _unref(reasonOptions),
              mode: "multiple",
              placeholder: "请选择异常原因",
              onChange: handleReceivedResCodeChange,
              "max-tag-count": 4
            }, null, 8, ["value", "options"]), _unref(showTextArea) ? (_openBlock(), _createBlock(_component_a_textarea, {
              key: 0,
              style: {
                "margin-top": "12px"
              },
              value: localRecord.value.receivedResMsg,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => localRecord.value.receivedResMsg = $event),
              rows: 4,
              placeholder: "请输入异常原因"
            }, null, 8, ["value"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "异常图片"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_upload, {
              "file-list": fileList.value,
              "onUpdate:file-list": _cache[2] || (_cache[2] = $event => fileList.value = $event),
              "list-type": "picture-card",
              onPreview: handlePreview,
              customRequest: handleUploadImage
            }, {
              default: _withCtx(() => [fileList.value.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(PlusOutlined)), _hoisted_2])) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["file-list"]), _createVNode(_component_a_modal, {
              open: previewVisible.value,
              title: previewTitle.value,
              footer: null,
              onCancel: handleCancel
            }, {
              default: _withCtx(() => [_createElementVNode("img", {
                alt: "example",
                style: {
                  "width": "100%"
                },
                src: previewImage.value
              }, null, 8, _hoisted_3)]),
              _: 1
            }, 8, ["open", "title"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["open"]);
    };
  }
});